import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const TransparentBottom = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  width: 284px;
  height: 50px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), ${COLORS.black} 30px) no-repeat;
`;

export default TransparentBottom;
